<template>
  <article class="node node-type-person" ref="personOverlay" :class="`theme-${theme}`">
    <div class="article-parent-wrapper" v-if="!isEmpty(node)">
      <div class="container-fluid  person-header article-gutter" :style="coverStyle" :class="{'hasCover' : (!showVideo && overlay)}">
        <div v-if="overlay" class="image-holder grayscale" :style="coverStyle">
        </div>
        <div class="row">
          <div class="col-12 content-wrapper mx-auto">
            <div class="person-top">
              <div v-if="overlay && node.related_video && showingOverlay" class="card-video-container" ref="cardVideoContainer">
                <card-video :nid="nid" :autoStart="false" :showCusPlayButton="true" theme="mobile" :isOverlay="overlay"></card-video>
              </div>
              <field-section class="node-label" v-if="!overlay && sections.length" :sections="sections"></field-section>
              <h1 class="person-name"><span>Who Is </span>{{node.title}}</h1>
              <div class="person-brief" v-if="node.subheading" v-html="node.subheading">{{node.subheading}}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="container-fluid content-wrapper inner-content article-gutter">
        <field-date v-if="!overlay" class="field-date" :node="node"></field-date>
        <share-pane v-if="!overlay" class="share-pane" :node="node"></share-pane>
        <field-body ref="articleBody" :body="node.body" :node="node" :bodyOptions="bodyOptions"></field-body>
      </div>

      <div class="container-fluid timeline-wrapper">
        <timeline class="no-article-swipe row" v-if="isEmptyTimeline" :nid="nid" :isOverlay="overlay"></timeline>
      </div>

      <!--Desktop Grid Pane-->
      <div v-if="!overlay" class="container-fluid panes-wrapper hidden-sm-down">
        <div class="row">
          <div class="col-sm-4 pane-column" v-for="(group, index) in desktopGridLayout">

            <template v-for="(item, index) in group">
              <property-pane v-if="item.type === 'property'" class="property-pane article-gutter pane" :property="item.data"></property-pane>
              <div v-else-if="item.type === 'history'" class="career-history-pane article-gutter pane">
                <h3 class="career-history-title">career history</h3>
                <ul class="pane-list">
                  <li v-for="(career, key) in item.data" :key="key">{{career}}</li>
                </ul>
              </div>

              <div v-else-if="item.type === 'awards'" class="awards-publication-pane  article-gutter pane">
                <h3 class="awards-publication-title">awards & publication</h3>
                <div class="attr-label-tag" v-if="!isEmpty(item.data.awards)">awards</div>
                <ul class="pane-list">
                  <li v-for="(award, key) in item.data.awards" :key="key">{{award}}</li>
                </ul>
                <div class="attr-label-tag" v-if="!isEmpty(item.data.publications)">publications</div>
                <ul class="pane-list">
                  <li v-for="(publication, key) in item.data.publications" :key="key">{{publication}}</li>
                </ul>
              </div>

              <div class="quotes-pane pane article-gutter col-12" v-else-if="item.type === 'quote'">
                <transition-group name="list" tag="div">
                  <quote-block class="quote-block" v-for="(quote, index) in node.quotes" v-if="index === 0 || showQuotes" :value="quote" :key="index"></quote-block>
                </transition-group>
                <div v-if="!showQuotes && node.quotes.length > 1" class="load-more-button" @click="showQuotes = true">show more quotes({{node.quotes.length - 1}})</div>
              </div>

              <div v-else-if="item.type === 'relatedArticles'" class="related-articles-pane article-gutter pane">
                <h3>related articles</h3>
                <transition-group name="list" tag="div">
                  <article-level-one class="article-level-one" v-for="(nid, index) in relatedArticles" :nid="nid" :key="index" :class="{first: index === 0, last: index === relatedArticles.length - 1}"></article-level-one>
                </transition-group>
                <loader v-if="loading"></loader>
                <div v-else-if="!noMoreContent" class="load-more-button" @click="loadMoreRelatedArticles">show more articles</div>

              </div>

              <div v-else-if="item.type === 'tag'" class="tags-wrapper  article-gutter pane">
                <tag :node="node"></tag>
              </div>

              <article-gallery class="gallery-pane" v-else-if="item.type === 'slideshow'" :nid="nid" theme="mobile"></article-gallery>

              <div v-else-if="item.type === 'random-people'" class="pane article-gutter random-people-pane">
                <h3>{{lastSection.title}}</h3>
                <div v-for="(person, index) in randomPeople">
                  <node-link class="random-person" :url="person.relative_url" :type="person.type" :nid="person.nid" :title="person.title">{{person.title}}</node-link>
                </div>
              </div>

            </template>
          </div>
        </div>
      </div><!-- End of Desktop Grid Pane-->

      <!--Mobile Grid Pane-->
      <div class="container-fluid  article-gutter panes-wrapper" :class="[{'hidden-sm-up': !overlay}, {overlay}]">
        <div class="row no-article-gutter">
          <template v-for="(property, key, index) in node.properties">
            <property-pane v-if="!isEmpty(property)" class="property-pane article-gutter pane col-12" :key="key" :property="property"></property-pane>
            <div class="career-history-pane article-gutter pane col-12" v-if="index === 0 && !isEmpty(node.history)">
              <h3 class="career-history-title">career history</h3>
              <ul class="pane-list">
                <li v-for="(career, key) in node.history" :key="key">{{career}}</li>
              </ul>
            </div>
          </template>
          <div class="awards-publication-pane  article-gutter pane col-12" v-if="node.awards || node.publication">
            <h3 class="awards-publication-title">awards & publication</h3>
            <div class="attr-label-tag" v-if="!isEmpty(node.awards)">awards</div>
            <ul class="pane-list">
              <li v-for="(award, key) in node.awards" :key="key">{{award}}</li>
            </ul>
            <div class="attr-label-tag" v-if="!isEmpty(node.publications)">publications</div>
            <ul class="pane-list">
              <li v-for="(publication, key) in node.publications" :key="key">{{publication}}</li>
            </ul>
          </div>

          <div class="quotes-pane pane article-gutter col-12" v-if="node.quotes">
            <transition-group name="list" tag="div">
              <quote-block class="quote-block" v-for="(quote, index) in node.quotes" v-if="index === 0 || showQuotes" :value="quote" :key="index"></quote-block>
            </transition-group>
            <div v-if="!showQuotes && node.quotes.length > 1" class="load-more-button" @click="showQuotes = true">show more quotes({{node.quotes.length - 1}})</div>
          </div>

          <div class="related-articles-pane article-gutter pane col-12" v-if="!isEmpty(relatedArticles)">
            <h3>related articles</h3>
            <transition-group name="list" tag="div">
              <article-level-one class="article-level-one" v-for="(nid, index) in relatedArticles" :nid="nid" :key="index" :class="{first: index === 0, last: index === relatedArticles.length - 1}"></article-level-one>
            </transition-group>

            <loader v-if="loading"></loader>
            <div v-else-if="!noMoreContent" class="load-more-button" @click="loadMoreRelatedArticles">show more articles</div>
          </div>

          <article-gallery class="gallery-pane" :nid="nid" theme="mobile"></article-gallery>

          <div class="tags-wrapper article-gutter pane col-12">
            <tag :node="node"></tag>
          </div>

          <div class="pane article-gutter random-people-pane col-12" v-if="!isEmpty(randomPeople)">
            <h3>{{lastSection.title}}</h3>
            <div v-for="(person, index) in randomPeople">
              <node-link class="random-person" :url="person.relative_url" :type="person.type" :nid="person.nid" :title="person.title">{{person.title}}</node-link>
            </div>
          </div>

        </div>
      </div><!-- End of Mobile Grid Pane-->
    </div>
    <loader class="loader" v-else></loader>
  </article>
</template>

<script>
  import get from 'lodash/get'
  import filter from 'lodash/filter'
  import forEach from 'lodash/forEach'
  import map from 'lodash/map'
  import head from 'lodash/head'
  import keys from 'lodash/keys'
  import slice from 'lodash/slice'
  import concat from 'lodash/concat'
  import isEmpty from 'lodash/isEmpty'
  import throttle from 'lodash/throttle'
  import set from 'lodash/set'
  import values from 'lodash/values'
  import shuffle from 'lodash/shuffle'

  import ArticleLevelOne from 'components/article-levels/Lv1.vue'
  import NodeLink from 'components/node/Link'
  import NodeLabel from 'components/node/Label.vue'
  import SharePane from 'components/node/SharePane.vue'
  import Tag from 'components/node/Tag.vue'
  import ShareButtons from 'components/widgets/ShareButtons.vue'
  import CardVideo from 'components/node/CardVideo.vue'

  import PropertyPane from 'components/node/person/PropertyPane.vue'
  import ArticleGallery from 'components/article/ArticleGallery.vue'
  import Loader from 'components/common/Loader.vue'

  import FieldDate from 'components/node/fields/Date.vue'
  import FieldBody from 'components/node/fields/Body.vue'
  import BodyHead from 'components/node/fields/BodyHead.vue'
  import FieldSection from 'components/node/fields/Section.vue'
  import QuoteBlock from 'components/node/QuoteBlock.vue'
  import Timeline from 'components/node/person/Timeline.vue'

  import Gallery from 'components/gallery/Gallery'
  import lazyloadImage from 'components/mixins/lazyloadImage'
  import mixinSection from 'components/mixins/section'

  import SvgIconArrowDownOne from 'static/svg/icon_arrow_down1.svg'
  import SvgIconArrowLeft from 'static/svg/icon_arrow_left.svg'
  import SvgGallery from 'static/svg/icon_gallery.svg'

  import { mapActions, mapState } from 'vuex'
  import { supportPassive } from 'mixins/utilities'
  import EventBus from 'components/helpers/event-bus'

  const relatedNodeLimit = 5

  export default {
    name: 'person-body',
    props: {
      nid: [Number, String],
      overlay: {
        type: Boolean,
        default: false,
      },
      showingOverlay: false,
      theme: {
        type: [String, Boolean],
        default: '',
      },
    },
    data() {
      return {
        bodyOptions: {
          countDown: false,
          photoOverlay: true,
          inlineNewsletter: false,
        },
        atBottom: false,
        headerMode: '',
        direction: false,
        lastPosition: 0,
        offset: 0,
        noMoreContent: false,
        loading: false,
        showQuotes: false,
      }
    },
    mixins: [lazyloadImage, mixinSection],
    components: {
      SharePane,
      NodeLink,
      NodeLabel,
      Tag,
      FieldBody,
      FieldDate,
      FieldSection,
      BodyHead,
      PropertyPane,
      Gallery,
      SvgIconArrowDownOne,
      SvgIconArrowLeft,
      SvgGallery,
      Loader,
      ShareButtons,
      CardVideo,
      ArticleLevelOne,
      ArticleGallery,
      QuoteBlock,
      Timeline,
    },
    methods: {
      ...mapActions([
        'toggleRelatedPersonOverlay',
      ]),
      isEmpty,
      fetchRelated(nid) {
        this.$store.dispatch('fetchRelatedNodes', { type: this.type, nid, offset: this.offset, limit: relatedNodeLimit }).then((hasContent) => {
          this.noMoreContent = !hasContent
        })
        if (this.type === 'person') {
          this.$store.dispatch('fetchRandomPeople', { limit: 6})
        }
      },
      loadMoreRelatedArticles() {
        if (!this.noMoreContent) {
          this.loading = true
          this.offset += relatedNodeLimit
          this.$store.dispatch('fetchRelatedNodes', { type: this.type, nid: this.nid, offset: this.offset, limit: relatedNodeLimit }).then((hasContent) => {
            this.noMoreContent = !hasContent
            setTimeout(() => {
              this.loading = false
            }, 800)
          })
        }
      },
    },
    mounted() {
      EventBus.$emit('nodeBodyMounted')

      // Fetch related article list
      if (get(this, 'nid')) {
        this.fetchRelated(this.nid)
      }

      const personOverlayWrapper = this.$refs.personOverlay.parentElement
      const passive = supportPassive() ? { passive: true } : false
      personOverlayWrapper.addEventListener('scroll', throttle((_e) => {
        const scrollY = personOverlayWrapper.scrollTop
        this.direction = scrollY > this.lastPosition ? 'down' : 'up'
        this.lastPosition = scrollY
        this.atBottom = scrollY > 60 && this.direction === 'down'
        this.headerMode = this.atBottom ? 'collapse' : ''
      }, 300), passive)
    },
    computed: {
      ...mapState([
        'relatedPersonOverlay',
        'nodes',
      ]),
      type() {
        if (get(this, 'node.type') === 'person') {
          return 'person'
        }
        return 'whatis'
      },
      // hot fix for empty timeline
      isEmptyTimeline() {
        if (!isEmpty(this.node.timeline)) {
          let result = true
          forEach(this.node.timeline, (timeline) => {
            result = result && !isEmpty(timeline)
          })
          return result
        }
        return false
      },
      node() {
        return this.$store.getters.node(this.nid) || {}
      },
      coverStyle() {
        if (!this.showVideo && this.overlay) {
          if (get(this, 'node.images[0].style_600x600', false)) {
            return {
              'background-image': `url('${get(this, 'node.images[0].style_600x600')}')`,
            }
          }
        }
        return {}
      },
      showVideo() {
        return (get(this, 'node.related_video[0].orientation') === 'square')
      },
      relatedArticles() {
        const queue = this.$store.getters.personRelatedNodesQueue(`node-related-nodes-${this.nid}`) || {}
        return map(keys(queue), o => queue[o])
      },
      sections() {
        const sections = []
        forEach(get(this, 'node.sections', []), (sectionLineage) => {
          const sectionList = map(sectionLineage, this.$store.getters.term)
          sections.push(sectionList)
        })
        return sections
      },
      slideshow() {
        const images = get(this, 'node.images', [])
        return filter(images, 'slideshow')
      },
      randomPeople() {
        if (this.type === 'person') {
          return shuffle(slice(filter(values(this.nodes), person => person.type === 'person' && person.nid !== this.nid), 0, 5))
        }
        return []
      },
      layout() {
        const node = this.node
        let output = []
        const properties = map(keys(node.properties), key => ({type: 'property', data: node.properties[key]}))

        // 1st property
        const firstProperty = head(properties)
        if (!isEmpty(firstProperty)) {
          output.push(firstProperty)
        }

        if (!isEmpty(node.history)) {
          output.push({
            type: 'history',
            data: node.history,
          })
        }

        const secondProperty = head(slice(properties, 1, 2))
        if (!isEmpty(secondProperty)) {
          output.push(secondProperty)
        }

        if (!isEmpty(node.awards) || !isEmpty(node.publications)) {
          output.push({
            type: 'awards',
            data: {
              awards: node.awards,
              publications: node.publications,
            },
          })
        }

        // Concat the rest Specifications pane if any
        output = concat(output, slice(properties, 2))

        if (!isEmpty(node.quotes)) {
          output.push({
            type: 'quote',
            data: node.quotes,
          })
        }

        if (!isEmpty(this.relatedArticles)) {
          output.push({
            type: 'relatedArticles',
            data: this.relatedArticles,
          })
        }

        if (!isEmpty(this.slideshow)) {
          output.push({
            type: 'slideshow',
            data: this.slideshow,
          })
        }

        output.push({
          type: 'tag',
          data: [],
        })

        return output
      },
      desktopGridLayout() {
        const layout = this.layout

        // if the first row is full, the 4th pane: awards
        // should go to the middle column
        // a placeholder has no use actually, just to pad the column
        if (get(layout, '[3].type', false) === 'awards') {
          layout.splice(3, 0, {type: 'placeholder'})
          layout.splice(5, 0, {type: 'placeholder'})
        }

        const thirdCol = filter(layout, (item, index) => index % 3 === 2)
        if (!isEmpty(this.randomPeople)) {
          thirdCol.push({
            type: 'random-people',
            data: [],
          })
        }
        return [
          filter(layout, (item, index) => index % 3 === 0),
          filter(layout, (item, index) => index % 3 === 1),
          thirdCol,
        ]
      },
    },
    watch: {
      relatedPersonOverlay(value) {
        if (!value.toggle) {
          setTimeout(() => {
            set(this, '$refs.personOverlay.parentElement.scrollTop', 0)
          }, 400)
        }
      },
      nid(newNid) {
        if (newNid && this.overlay) {
          this.fetchRelated(newNid)
          this.$store.dispatch('fetchNode', { nid: newNid })
        }
      },
    },
  }
</script>

<style lang="scss">
  .page-type-person .card-video-container {
    background-color: $oxford-blue-1;
  }

  .page-type-person .article-view-wrapper .arrow-down-wrapper {
    background-color: $person-bg-blue;
    @include respond-to('mobile') {
      padding-top: rem-calc(22);
      background-color: $white;
    }
  }

  .node-type-person {
    font-family: $roboto;
    a, .article-body a, a.link {
      color: $white;
      text-shadow: none;
    }

    &.theme-desktop .arrow-right-wrapper {
      margin-left: rem-calc(-35);
    }

    .share-pane {
      .share-toolbar {
        @include respond-to('desktop') {
          padding-top: rem-calc(27);
        }
      }

      .shareCount{
        color: $white;
        .shareText {
          padding-top: rem-calc(10);
        }
      }
    }
    // More specific CSS to reset
    .related-articles-pane .article-level-one {
      .card-title {
        font-size: rem-calc(16);
        line-height: rem-calc(20)
      }
      .card-section {
        color: $cadet-blue;
        font-size: rem-calc(12);
        line-height: rem-calc(16);
        @include respond-to('desktop') {
          font-size: rem-calc(14);
          line-height: rem-calc(18);
        }
      }
    }

    .tags-wrapper {
      font-family: $barlow;

      .tags-title {
        color: $rose;
        font-size: rem-calc(22);
        line-height: rem-calc(26);
        text-transform: uppercase;
        font-weight: bold;
        font-family: $barlow;
        display: block;
        @include respond-to('desktop') {
          line-height: rem-calc(30);
          font-size: rem-calc(24);
          margin-bottom: rem-calc(17);
        }
      }
      .tags h5 {
        @include respond-to('desktop') {
          margin-top: 0;
          &.first {
            margin-bottom: rem-calc(15);
            font-size: rem-calc(20);
            line-height: rem-calc(30);
          }
        }
        @include respond-to('mobile') {
          &.first {
            margin-top: rem-calc(8);
            &, & a {
              font-size: rem-calc(48);
              line-height: rem-calc(57);
            }
          }
          &, & a {
            color: $waterspout;
            font-size: rem-calc(18);
            line-height: rem-calc(30);
          }
        }
      }
    }

    .article-body h3 {
      font-family: $barlow;

      @include respond-to('desktop') {
        line-height: rem-calc(30);
        margin-bottom: rem-calc(8);
      }
      @include respond-to('mobile') {
        font-size: rem-calc(22);
        line-height: rem-calc(26);
        margin-bottom: rem-calc(12);
      }
    }

    .article-body p {
      @include respond-to('desktop') {
        font-size: rem-calc(18);
        line-height: rem-calc(30);
        margin-bottom: rem-calc(30);
      }
      @include respond-to('mobile') {
        margin-bottom: rem-calc(28);
      }
    }

    .gallery-wrapper {
      padding-bottom: 0;
      margin-left: 0;
      margin-right: 0;
      .gallery-container {
        overflow: hidden;
        .thumbnail {
          border-color: transparent;
        }
        .gallery {
          margin-left: rem-calc(-1.5);
          margin-right: rem-calc(-1.5);
        }
      }
    }
  }

  .node-type-person {
    .person-header {
      .person-top {
        position: relative;
        z-index: 1;

        .person-brief {
          font-size: rem-calc(22);
          line-height: rem-calc(30);
          margin-top: -0.5rem;
          color: $light-cornflower-blue;
          margin-bottom: 1rem;

          ul {
            padding-left: 1.5rem;
          }
        }
      }
    }
  }
  .node-type-person:not(.overlay) {
    .person-header .person-top .person-brief {
      font-size: rem-calc(18);
      line-height: rem-calc(26);
    }
  }

  .pane {
    background-color: $prussian-blue-2;
    @include respond-to('desktop') {
      margin-bottom: rem-calc(12);
      padding-top: rem-calc(28);
      padding-bottom: rem-calc(30);
    }
    @include respond-to('mobile') {
      margin-bottom: rem-calc(4);
      padding-top: rem-calc(24);
      padding-bottom: rem-calc(27);
    }

    h3 {
      font-family: $barlow;
      font-weight: bold;

      @include respond-to('desktop') {
        line-height: rem-calc(30);
        font-size: rem-calc(24);
        margin-bottom: rem-calc(20);
      }
      @include respond-to('mobile') {
        margin-bottom: rem-calc(16);
        font-size: rem-calc(22);
        line-height: rem-calc(26);
      }
    }
    &.gallery-pane {
      padding-top: 0;
      padding-bottom: 0;
    }
  }
</style>

<style scoped lang="scss">

  .list-enter-active, .list-leave-active {
    transition: all 1s;
  }
  .list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */ {
    opacity: 0;
  }

  .node-type-person {
    color: $white;
    background-color: $person-bg-blue;
    .field-date,
    .share-pane {
      color: $white;
      font-family: $barlow;
    }

    .field-date {
      @include respond-to('desktop') {
        font-size: rem-calc(14);
        line-height: rem-calc(16);
        text-align: left;
      }
    }
    .share-pane {
      padding-top: rem-calc(10);

      .share-count {
        margin-bottom: rem-calc(20)
      }
      @include respond-to('desktop') {
        padding-top: rem-calc(6);
        margin-bottom: rem-calc(40);
      }
    }

    &:not(.overlay) {
      /deep/ .tl-skinny {
        .tl-slidenav-next,
        .tl-slidenav-previous {
          visibility: hidden;
        }
      }
    }

    &.overlay {
      width: 100%;
      min-height: 100%;
      height: auto;

      .image-holder {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-position: 50%;
        background-size: cover;
        background-repeat: no-repeat;
      }
      &.theme-desktop {
        padding-top: rem-calc(75);
      }
      padding-top: rem-calc(50);
      padding-bottom: rem-calc(50);

      .person-header {
        &::after {
          background: linear-gradient(to bottom, rgba(0,0,0,0) 0%,rgba(0,0,0,0.5) 100%);
          content: " ";
          position: absolute;
          height: rem-calc(400);
          width: 100%;
          bottom: 0;
          left: 0;
          right: 0;
        }
      }
    }
    .loader {
      padding-top: rem-calc(20);
      height: auto;
    }


  }

  .timeline-wrapper {
    max-width: rem-calc(1260);
    margin-bottom: rem-calc(10);
    @include respond-to('desktop') {
      margin-bottom: rem-calc(110px);
    }
  }

  .prevent-article-swiping {
    width: 100%;
    position: fixed;
  }

  .overlay-header {
    padding: rem-calc(16 16 15);
    flex-direction: row;
    justify-content: space-between;
    display: flex;
    border-bottom: rem-calc(1) solid $black;
    background-color: $oxford-blue;

    transition: all .5s ease;
    position: fixed;
    background-color: red;
    z-index: 1200;
    width: 100%;

    &.collapse {
      .overlay-header-section {
        font-size: rem-calc(11);
        line-height: rem-calc(13);
      }
      .overlay-back-btn {
        width: rem-calc(12);
        height: rem-calc(11);
      }
    }

    .overlay-back-btn,
    .overlay-header-section {
      display: flex;
    }
    .overlay-header-section {
      font-size: rem-calc(14);
      line-height: rem-calc(16);
      font-weight: bold;
    }
  }

  .no-article-gutter {
    margin-left: rem-calc(-$mobile-article-gutter);
    margin-right: rem-calc(-$mobile-article-gutter);
  }

  .article-gutter {
    padding-left: rem-calc($mobile-article-gutter);
    padding-right: rem-calc($mobile-article-gutter);
  }

  .inner-content {
    @include respond-to('desktop') {
      padding-top: rem-calc(40);
    }
    @include respond-to('mobile') {
      padding-top: rem-calc(12);
      margin-bottom: rem-calc(40);
    }
  }

  .attr-label-tag {
    font-weight: bold;
    font-family: $barlow;
    color: $cadet-blue;
    text-transform: uppercase;
    margin-bottom: rem-calc(6);
    @include respond-to('desktop') {
      font-size: rem-calc(18);
      line-height: rem-calc(21);
    }
    @include respond-to('mobile') {
      font-size: rem-calc(16);
      line-height: rem-calc(19);
    }
  }

  .content-wrapper {
    @include respond-to('desktop') {
      max-width: rem-calc(700);
    }
  }

  .person-header {
    background-color: $prussian-blue-2;
    padding-top: rem-calc(34);
    padding-bottom: 0;
    color: $white;

    @include respond-to('desktop') {
      padding-bottom: rem-calc(11);
    }
    &.hasCover{
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
      padding-top: 72%;
    }

    .node-label {
      text-transform: uppercase;
      margin-bottom: rem-calc(4);
      color: $radical-red;
      font-weight: bold;
      @include respond-to('desktop') {
        font-size: rem-calc(20);
        line-height: rem-calc(24);
      }
      @include respond-to('mobile') {
        font-size: rem-calc(14);
        line-height: rem-calc(16);
      }
    }

    .person-name {
      color: $white;
      font-weight: normal;
      font-family: $bungee;
      text-transform: uppercase;
      margin-bottom: rem-calc(4);
      @include respond-to('desktop') {
        font-size: rem-calc(50);
        line-height: rem-calc(50);
      }
      @include respond-to('mobile') {
        font-size: rem-calc(40);
        line-height: rem-calc(40);
      }
      span {
        font-size: 0;
        color: transparent;
      }
    }    .person-brief {
      font-family: $barlow;
      @include respond-to('desktop') {
        font-size: rem-calc(32);
        line-height: rem-calc(40);
      }
      @include respond-to('mobile') {
        font-size: rem-calc(22);
        line-height: rem-calc(28);
      }
    }
  }

  .pane-list {
    padding-left: rem-calc(20);
    li {
      padding-left: rem-calc(12);
      margin-bottom: rem-calc(15);
      @include respond-to('desktop') {
        font-size: rem-calc(18);
        line-height: rem-calc(24);
      }
    }
  }

  .pane-column {
    padding-left: rem-calc(10.5);
    padding-right: rem-calc(10.5);

    h3 {
      font-size: rem-calc(24px);
      line-height: rem-calc(30px);
    }
  }

  .panes-wrapper:not(.overlay) {
    max-width: calc(1260px + 21px);
    @include respond-to('desktop') {
      padding-bottom: rem-calc(182);
    }
  }

  .tags-wrapper {
    @include respond-to('mobile') {
      margin-bottom: 0;
    }
  }

  .awards-publication-pane {
    .pane-list {
      text-transform: uppercase;
    }
  }

  .random-people-pane {
    background-color: $white;
    padding-top: rem-calc(20);
    padding-bottom: rem-calc(20);
    @include respond-to('mobile') {
      margin-bottom: 0;
    }

    h3 {
      font-family: $barlow;
      color: $radical-red;
      line-height: rem-calc(43);
      margin-bottom: rem-calc(8);
      font-size: rem-calc(36);
    }
    .random-person {
      font-family: $barlow;
      font-size: rem-calc(20);
      line-height: rem-calc(36);
      text-transform: capitalize;
      color: $black;
      font-weight: bold;
      border-bottom: 1px solid $rose;
      text-decoration: none;
    }
  }

  .quotes-pane {
    padding-top: rem-calc(10);
    padding-bottom: 0;

    .quote-block {
      background-color: transparent;
    }
  }

  .related-articles-pane {
    font-family: $barlow;
    .article-level-one {
      font-family: $barlow;
    }

    .load-more-button {
      margin-top: rem-calc(31);
    }
    h3 {
      font-family: $barlow;
      margin-bottom: rem-calc(28);
    }
  }

  .card-video-container {
    margin-bottom: rem-calc(20);
    /deep/ .video-container .button-wrapper.close-button-wrapper {
      display: none;
    }
  }
  .article-level-one:not(.last) {
    margin-bottom: rem-calc(28);
  }

  .article-parent-wrapper {
    background: none;
  }

  .load-more-button {
    font-size: rem-calc(15);
    line-height: rem-calc(26);
    display: block;
    background-color: $waterspout;
    font-family: $barlow;
    font-weight: bold;
    color: $black;
    text-align: center;
    text-transform: uppercase;
  }

  .theme-desktop {
    .content-wrapper {
      padding-left: rem-calc(117.5);
      padding-right: rem-calc(42.5);
    }
    .timeline-wrapper {
      padding-left: calc(117.5px + 15px);
      padding-right: calc(42.5px + 15px);
    }
    .panes-wrapper {
      padding-left: calc(117.5px + 27px);
      padding-right: calc(42.5px + 27px);
    }
    .card-video-container {
      margin-bottom: rem-calc(0);
      /deep/ .card-video {
        margin-bottom: rem-calc(40);
      }
    }
    .person-name {
      margin-bottom: rem-calc(8);
    }
    .overlay .person-header {
      padding-bottom: rem-calc(2);
    }
    .inner-content {
      padding-top: rem-calc(40.5);
    }
    .timeline-wrapper {
      margin-bottom: rem-calc(30);
    }
  }

  .overlay .timeline-wrapper {
    margin-bottom: rem-calc(4);
  }

  .overlay.theme-desktop .timeline-wrapper {
    margin-bottom: rem-calc(12);
  }

  .field-section {
    font-family: $barlow;
  }

</style>



// WEBPACK FOOTER //
// PersonBody.vue?6ec3df43